import getTimeGridHeight from '../utils/getTimeGridHeight';
import GridLayer from './GridLayer';
import LayerStack from './LayerStack';
import React from 'react';
import ScrollIntoViewHelper from './ScrollIntoViewHelper';
import ScrollIntoViewInfo, { ScrollIntoView } from '../schema/ScrollIntoView';
import { DateRange } from 'mini-datetime-utils';
import { DEFAULT_PIXELS_PER_MINUTE } from '../utils/constants';
import { GridLayerInfo } from '../schema/GridLayerInfo';
import { Layer } from '../schema/Layer.types';
import { mergeStyles } from '@uifabric/styling';

const classNames = require('classnames');
const styles = require('./TimeGridLayout.scss');

export interface TimeGridLayoutProps {
    range: DateRange;
    gridLayerInfo: GridLayerInfo;
    layers?: Layer[];
    scrollIntoViewInfo?: ScrollIntoViewInfo;
    pixelsPerMin?: number;
    onClickAllDayLabel?: (isExpanded: boolean) => void;
}

export default function TimeGridLayout(props: TimeGridLayoutProps) {
    const defaultScrollIntoViewInfo: ScrollIntoViewInfo = {
        topPosition: 0,
        scrollIntoViewType: ScrollIntoView.Top,
    };
    const {
        range,
        gridLayerInfo,
        layers,
        scrollIntoViewInfo = defaultScrollIntoViewInfo,
        pixelsPerMin = DEFAULT_PIXELS_PER_MINUTE,
        onClickAllDayLabel,
    } = props;
    const { start, end } = range;
    const timeGridContainerClass = mergeStyles({
        height: `${getTimeGridHeight(start, end, pixelsPerMin)}px`,
    });

    return (
        <div className={classNames(styles.container, timeGridContainerClass)}>
            <GridLayer
                range={range}
                gridInfo={gridLayerInfo}
                pixelsPerMin={pixelsPerMin}
                onClickAllDayLabel={onClickAllDayLabel}
            />
            <LayerStack layers={layers} />
            <ScrollIntoViewHelper scrollIntoViewInfo={scrollIntoViewInfo} />
        </div>
    );
}
